import Breadcrumb from './../../components/BreadCrumb';
import ServiceComponent from './../../components/ServiceComponent';
import HeadingDetailsSection from './../../sections/HeadingDetailsSection';
import { faDollarSign, faClock, faFileContract } from '@fortawesome/free-solid-svg-icons';
import image from './../../assets/pexels/legaltech.jpg'

function FixedFeeLegalServiceScreen() {
  return (
    <>
        <HeadingDetailsSection heading='Fixed Fee Legal Services'>
          <Breadcrumb parent="Services" screen='Fixed Fee Legal Services'/>
        </HeadingDetailsSection>
        <ServiceComponent
          heading="Fixed Fee Legal Services"
          description="PocketLPO offers Fixed Fee Legal Services to provide predictable and transparent pricing for specific tasks. Ideal for businesses looking to manage costs without compromising on quality."
          services={[
            "Privacy policy drafting and compliance reviews.",
            "Contract negotiation support.",
            "Employee handbook creation."
          ]}
          benefits={[
            { title: "Transparent Pricing", description: "No hidden fees.", icon: faDollarSign },
            { title: "Efficient Solutions", description: "Quick turnaround times for predefined tasks.", icon: faClock },
            { title: "Cost Control", description: "Budget-friendly options for essential legal work.", icon: faFileContract }
          ]}
          image={image}
        />
    </>
  );
}

export default FixedFeeLegalServiceScreen;
